(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const randomBetween = (minimum, maximum) =>
    Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;

  const initialiseGridFlow = (grid) => {
    if (!grid || grid.dataset.gridFlowInitialised || prefersReducedMotion.matches) return;

    const lines = Array.from(grid.querySelectorAll('.footer__grid-line')).filter(
      (line) => !line.matches(':first-child, :last-child')
    );
    if (!lines.length) return;

    grid.dataset.gridFlowInitialised = 'true';
    const timers = new Set();

    const schedule = (callback, delay) => {
      const timer = window.setTimeout(() => {
        timers.delete(timer);
        callback();
      }, delay);
      timers.add(timer);
    };

    const launch = (line) => {
      if (!document.body.contains(grid) || prefersReducedMotion.matches) return;

      const duration = randomBetween(6200, 9800);
      line.style.setProperty('--footer-flow-duration', `${duration}ms`);
      line.style.setProperty('--footer-flow-start', `${randomBetween(-55, -25)}%`);
      line.classList.add('is-flowing');

      line.addEventListener(
        'animationend',
        () => {
          line.classList.remove('is-flowing');
          schedule(() => launch(line), randomBetween(9000, 18000));
        },
        { once: true }
      );
    };

    lines.forEach((line) => schedule(() => launch(line), randomBetween(200, 9000)));
    grid.addEventListener(
      'shopify:section:unload',
      () => timers.forEach((timer) => window.clearTimeout(timer)),
      { once: true }
    );
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-footer-grid-flow]').forEach(initialiseGridFlow);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
